import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  label: string;
  value?: React.ReactNode;
  rightNode?: React.ReactNode;
};

const InfoRow: React.FC<Props> = ({ label, value, rightNode }) => {
  const showValue = value !== undefined;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body2" sx={{ flex: '0 0 140px', color: 'text.secondary' }}>
        {label}
      </Typography>

      {showValue && (
        <Typography variant="body2" sx={{ flex: 1, fontWeight: 500, mr: 1 }}>
          {value ?? '—'}
        </Typography>
      )}

      {rightNode}
    </Box>
  );
};

export default InfoRow;
